/* =====================================================================
   Elevana — product-card weight buttons + Add to Cart
   ---------------------------------------------------------------------
   Each card (homepage + collection) renders, under the price:
     • weight buttons (one per real variant — no hard-coded data)
     • a self-contained product form with a visible "Add to Cart" button
       wired to the theme's <product-form-component> (AJAX + cart drawer).

   This script just keeps the form's hidden variant id, the button label,
   and the displayed price in sync with the chosen weight. It also stops
   clicks inside the buy area from triggering the card's "navigate to
   product" behaviour, so picking a weight or adding to cart stays on page.

   Plain, dependency-free, event-delegated. Cart/checkout untouched.
   ===================================================================== */
(function () {
  'use strict';

  function selectWeight(btn) {
    var buy = btn.closest('.elevana-card-buy');
    if (!buy) return;

    var variantId = btn.getAttribute('data-variant-id');
    var available = btn.getAttribute('data-variant-available') === 'true';
    if (!variantId) return;

    // Active state across the weight buttons
    var buttons = buy.querySelectorAll('.elevana-weight');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    // Point the card's add-to-cart form at the chosen variant
    var form = buy.querySelector('form');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        if (available) idInput.removeAttribute('disabled');
        else idInput.setAttribute('disabled', '');
      }
    }

    // Reflect availability on the Add to Cart button
    var atc = buy.querySelector('.elevana-atc');
    if (atc) {
      var label = atc.querySelector('.elevana-atc__text');
      if (available) {
        atc.removeAttribute('disabled');
        if (label && atc.dataset.addLabel) label.textContent = atc.dataset.addLabel;
      } else {
        atc.setAttribute('disabled', '');
        if (label && atc.dataset.soldLabel) label.textContent = atc.dataset.soldLabel;
      }
    }

    updatePrice(btn);
  }

  function updatePrice(btn) {
    var card = btn.closest('product-card') || btn.closest('.product-card');
    if (!card) return;

    var price = btn.getAttribute('data-variant-price');
    var compare = btn.getAttribute('data-variant-compare');
    if (!price) return;

    var root = card.querySelector('product-price') || card.querySelector('.price');
    if (!root) return;

    var values = root.querySelectorAll('.price:not(.compare-at-price)');
    for (var i = 0; i < values.length; i++) values[i].textContent = price;

    var compares = root.querySelectorAll('.compare-at-price');
    for (var j = 0; j < compares.length; j++) compares[j].textContent = compare || '';

    var regular = root.querySelector('.price__regular');
    var sale = root.querySelector('.price__sale');
    if (compare) {
      if (regular) regular.classList.add('price__hidden');
      if (sale) sale.classList.remove('price__hidden');
    } else {
      if (regular) regular.classList.remove('price__hidden');
      if (sale) sale.classList.add('price__hidden');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      // Any click inside the buy area must not navigate the card.
      if (target.closest('.elevana-card-buy')) {
        event.stopPropagation();
      }

      var btn = target.closest('.elevana-weight');
      if (!btn) return; // let the Add to Cart submit proceed normally
      event.preventDefault();
      selectWeight(btn);
    },
    true
  );
})();
